import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
	},{
		path: '/news',
		name: 'News',
		component: () => import(/* webpackChunkName: "news" */ '../views/news/listPage.vue'),
		meta: {
			title: '行业新闻'
		}
	},{
		path: '/newsDetail',
		name: 'NewsDetail',
		component: () => import(/* webpackChunkName: "newsDetail" */ '../views/news/newsDetail.vue'),
		meta: {
			title: '行业新闻-详情'
		}
	},{
		path: '/notice',
		name: 'Notice',
		component: () => import(/* webpackChunkName: "notice" */ '../views/notice/index.vue'),
		meta: {
			title: '平台公告'
		}
	},{
		path: '/noticeDetail',
		name: 'NoticeDetail',
		component: () => import(/* webpackChunkName: "noticeDetail" */ '../views/notice/noticeDetail.vue'),
		meta: {
			title: '平台公告-详情'
		}
	},{
		path: '/demand',
		name: 'Demand',
		component: () => import(/* webpackChunkName: "demand" */ '../views/demand/index.vue'),
		meta: {
			title: '需求市场'
		}
	},{
		path: '/resources',
		name: 'Resources',
		component: () => import(/* webpackChunkName: "resources" */ '../views/resources/index.vue'),
		meta: {
			title: '资源市场'
		}
	},{
		path: '/products',
		name: 'Products',
		component: () => import(/* webpackChunkName: "products" */ '../views/resources/pay.vue'),
		meta: {
			title: '资源市场-详情-支付'
		}
	},{
		path: '/demandUser',
		name: 'DemandUser',
		component: () => import(/* webpackChunkName: "user" */ '../views/user/demandUser.vue'),
		meta: {
			title: '个人中心-需求用户'
		}
	},{
		path: '/resourceUser',
		name: 'ResourceUser',
		component: () => import(/* webpackChunkName: "user" */ '../views/user/resourceUser.vue'),
		meta: {
			title: '个人中心-资源用户'
		}
	},{
		path: '/channelUser',
		name: 'ChannelUser',
		component: () => import(/* webpackChunkName: "user" */ '../views/user/channelUser.vue'),
		meta: {
			title: '个人中心-渠道用户'
		}
	},{
		path: '/mobileResource',
		name: 'MobileResource',
		component: () => import(/* webpackChunkName: "mobileResource" */ '../views/mobile/mobileResource.vue'),
		meta: {
			title: '小屏幕-移动端-发布资源页面'
		}
	},{
		path: '/mobileDemand',
		name: 'MobileDemand',
		component: () => import(/* webpackChunkName: "mobileDemand" */ '../views/mobile/mobileDemand.vue'),
		meta: {
			title: '小屏幕-移动端-发布需求页面'
		}
	},{
		path: '/mobilePay',
		name: 'MobilePay',
		component: () => import(/* webpackChunkName: "mobilePay" */ '../views/mobile/mobilePay.vue'),
		meta: {
			title: '小屏幕-移动端-支付资源页面'
		}
	},{
		path: '/mobileLogin',
		name: 'MobileLogin',
		component: () => import(/* webpackChunkName: "mobileLogin" */ '../views/mobile/mobileLogin.vue'),
		meta: {
			title: '小屏幕-移动端-登录页面'
		}
	},{
		path: '/mobileRegister',
		name: 'MobileRegister',
		component: () => import(/* webpackChunkName: "mobileRegister" */ '../views/mobile/mobileRegister.vue'),
		meta: {
			title: '小屏幕-移动端-注册页面'
		}
	},{
		path: '/mobileRegisterForm1',
		name: 'MobileRegisterForm1',
		component: () => import(/* webpackChunkName: "mobileRegisterForm1" */ '../views/mobile/register/form1.vue'),
		meta: {
			title: '小屏幕-移动端-注册页面-1'
		}
	},{
		path: '/mobileRegisterForm2',
		name: 'MobileRegisterForm2',
		component: () => import(/* webpackChunkName: "mobileRegisterForm2" */ '../views/mobile/register/form2.vue'),
		meta: {
			title: '小屏幕-移动端-注册页面-2'
		}
	},{
		path: '/mobileRegisterForm3',
		name: 'MobileRegisterForm3',
		component: () => import(/* webpackChunkName: "mobileRegisterForm3" */ '../views/mobile/register/form3.vue'),
		meta: {
			title: '小屏幕-移动端-注册页面-3'
		}
	}
	
	
]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
